import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import favicon from "./assets/images/favicon.png";
import { useAuthStore } from "./store/authStore";
import { RECAPTCHA_SITE_KEY } from "./constants";
import { AppProviders } from "./providers/AppProviders";
import { getBasePathWithoutTrailingSlash } from "./utils/basePath";
import { RouteSeo } from "./components/seo";
import { appRoutes } from "./routes/appRoutes";

function App() {
  const initializeAuth = useAuthStore((state) => state.initializeAuth);

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  useEffect(() => {
    const reinitialize = () => initializeAuth();
    const onStorage = (e: StorageEvent) => {
      if (!e.key) return;
      const k = e.key.toLowerCase();
      if (
        k === "__auth_event__" ||
        k === "access_token" ||
        k === "refresh_token" ||
        k === "user_data"
      ) {
        initializeAuth();
      }
    };

    window.addEventListener(
      "auth:token-changed",
      reinitialize as EventListener
    );
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(
        "auth:token-changed",
        reinitialize as EventListener
      );
      window.removeEventListener("storage", onStorage);
    };
  }, [initializeAuth]);

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/svg";
    link.href = favicon;
    document.head.appendChild(link);
  }, []);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <BrowserRouter basename={getBasePathWithoutTrailingSlash()}>
        <RouteChangeTracker />
        <RouteSeo />
        <AppProviders>
          <Routes>
            {appRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </AppProviders>
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  );
}

export default App;

function RouteChangeTracker() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location]);
  return null;
}
